import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseCellComponent } from '../base-cell.component';

/**
 * Ячейка с HTML
 */
@Component({
    selector: 'app-html-cell',
    template: '<span [innerHtml]="getRawValue()"></span>',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HtmlCellComponent extends BaseCellComponent {}
